import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../ui/Button';
import MobileNav from './MobileNav';
import Logo from './Logo';

export const NAV = [
  { to: '/work', label: 'Work' },
  { to: '/services', label: 'Services' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/industries', label: 'Industries' },
  { to: '/ads', label: 'Ads' },
  { to: '/demos', label: 'Demos' },
];

// Fixed header: transparent over the hero, blurred surface after 80 px,
// hides on scroll-down and returns on scroll-up.
export default function Header() {
  const { isAuthenticated } = useAuth();
  const [solid, setSolid] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let last = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        setSolid(y > 80);
        setHidden(y > 160 && y > last);
        last = y;
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const shell = hidden && !open ? '-translate-y-full' : 'translate-y-0';
  const surface = solid ? 'bg-ink/95 border-b border-line' : 'bg-transparent border-b border-transparent';

  return (
    <>
      <header className={'fixed inset-x-0 top-0 z-50 transition-all duration-500 ease-expo ' + shell + ' ' + surface}>
        <div className="container-x flex h-16 items-center justify-between md:h-20">
          <Link to="/" className="flex items-center gap-2.5" aria-label="Bluprise home">
            <Logo className="h-7 w-7" />
            <span className="font-display text-xl font-semibold tracking-tight">
              Blu<span className="text-sky">prise</span>
            </span>
          </Link>
          <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => 'text-[15px] tracking-tight transition-colors ' + (isActive ? 'text-cream' : 'text-mist hover:text-cream')}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-3 lg:flex">
            <Link to={isAuthenticated ? '/hub' : '/login'} className="text-[15px] text-mist hover:text-cream transition-colors">
              {isAuthenticated ? 'Hub' : 'Sign in'}
            </Link>
            <Button to="/contact" size="sm">Start a project</Button>
          </div>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-line lg:hidden"
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </header>
      <MobileNav open={open} onClose={() => setOpen(false)} isAuthenticated={isAuthenticated} />
    </>
  );
}
